import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  gymSocialBodyText,
  gymSocialDetailPanel,
  gymSocialItemText,
  gymSocialMutedText,
  gymSocialSectionLabel,
} from '../gymPageTheme';
import {
  formatAutomationConditionLabel,
  formatAutomationStepLabel,
  formatAutomationTriggerSummary,
} from './gymEmailAutomationFormat';

export default function GymEmailAutomationRuleDetails({ automation, meta, tags, templates }) {
  const { t } = useTranslation();
  if (!automation) return null;

  const triggerLabel =
    (meta.triggers || []).find((tr) => tr.code === automation.trigger_code)?.label
    || automation.trigger_code;

  const conditions = automation.conditions || [];
  const steps = automation.steps || [];

  return (
    <div className={`mt-2 text-xs space-y-2.5 ${gymSocialDetailPanel}`}>
      <div>
        <p className={gymSocialSectionLabel}>
          {t('gym.email.automations.detailWhen')}
        </p>
        <p className={gymSocialItemText}>
          {formatAutomationTriggerSummary({
            triggerCode: automation.trigger_code,
            triggerConfig: automation.trigger_config,
            triggerLabel,
            tags,
            t,
          })}
        </p>
      </div>

      <div>
        <p className={gymSocialSectionLabel}>
          {t('gym.email.automations.detailIf')}
        </p>
        {conditions.length === 0 ? (
          <p className={gymSocialMutedText}>{t('gym.email.automations.listNoConditions')}</p>
        ) : (
          <ul className={`space-y-0.5 ${gymSocialBodyText}`}>
            {conditions.map((cond, i) => (
              <li key={i}>· {formatAutomationConditionLabel(cond, meta, tags)}</li>
            ))}
          </ul>
        )}
      </div>

      <div>
        <p className={gymSocialSectionLabel}>
          {t('gym.email.automations.detailThen')}
        </p>
        <ol className={`space-y-0.5 list-decimal list-inside ${gymSocialBodyText}`}>
          {steps.map((step, i) => (
            <li key={i}>{formatAutomationStepLabel(step, meta, tags, templates, t)}</li>
          ))}
        </ol>
      </div>
    </div>
  );
}
